import { createStrings } from '@utils/local';
import { PageMeta } from '@utils/pages';

const strings = createStrings({
  ja: {
    title: 'ルート管理',
  },
});

export const meta: PageMeta = {
  title: strings.title,
  listed: true,
  staffOnly: true,
  rolesOnly: ['admin', 'FCJapan'],
  order: 3,
};
